import { ReactNode } from 'react'
import { ObjectProperties } from '../../shared/types'
import { ObjectAggregateT, ObjectTypes, useObjectAggregate } from '../api/object'
import { LOADING } from '../components/loading'

export function ObjectAggregate({
	object,
	children,
	related,
}: {
	object: keyof ObjectTypes
	children: (row: ObjectAggregateT) => ReactNode
	related?: ObjectProperties
}) {
	const query = useObjectAggregate(object, related)

	if (query.isLoading) {
		return (
			<tr>
				<td className="flex items-center p-6">
					{LOADING}
					Načítám…
				</td>
			</tr>
		)
	}
	if (!query.isSuccess) {
		return null
	}
	const data = query.data
	if (!data.length) {
		return null
	}

	return data.map(row => children(row))
}
